export const data = {
  "La mutuelle de Verspieren": {
    "_config": {
      icon: "sante",
      text: ""
    },
    "Oui": {},
    "Non": {},
  },
  "Une assurance pour particulier": {
    "_config": {
      icon: "client",
      text: ""
    },
    "Assurance habitation": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Travaux": {
      "_config": {
        icon: "",
        text: "Dommages ouvrages"
      },
      "Oui": {},
      "Non": {},
    },
    "Auto et/ou moto": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Instrument de musique": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Assurance emprunteur": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Garantie des loyers impayés": {
      "_config": {
        icon: "",
        text: ""
      },
    },
    "Mon achat chez Electro Dépôt": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Mon achat sur Rakuten": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Assurance scolaire": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Activité sportive": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Un autre sujet": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
  },
  "Une assurance pour professionnel ou entreprise": {
    "_config": {
      icon: "pro",
      text: ""
    },
    "Responsabilité civile": {
      "_config": {
        icon: "",
        text: "RCP, RCMS, garantie financière... "
      },
      "Oui": {},
      "Non": {},
    },
    "Dommages aux biens": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Flotte de véhicules": {
      "_config": {
        icon: "",
        text: "6 véhicules minimum hors engin"
      },
      "Oui": {},
      "Non": {},
    },
    "Construction": {
      "_config": {
        icon: "",
        text: "DO, décennale, TRC, CNR..."
      },
      "Oui": {},
      "Non": {},
    },
    "Risques cyber": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Complémentaire santé": {
      "_config": {
        icon: "",
        text: "Pour mes collaborateurs et moi"
      },
      "Oui": {},
      "Non": {},
    },
    "Prévoyance": {
      "_config": {
        icon: "",
        text: "Pour mes collaborateurs et moi"
      },
      "Oui": {},
      "Non": {},
    },
    "Epargne retraite": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Affinitaire": {
      "_config": {
        icon: "",
        text: "Création d’une assurance pour mes clients"
      },
      "Oui": {},
      "Non": {},
    },
    "Risques financiers": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Transport de marchandises": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "J'ai besoin des conseils d'un professionnel": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Un autre sujet": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
  },
  "Professionnel : une demande sur un de nos assurés": {
    "_config": {
      icon: "prospect",
      text: ""
    },
    "Demande de prise en charge (DPEC)": {
      "_config": {
        icon: "",
        text: ""
      },
      "Optique": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Dentaire": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Hospitalisation": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Autre": {
        "_config": {
          icon: "",
          text: ""
        }
      },
    },
    "Attente de paiement ou rejet de tiers-payant": {
      "_config": {
        icon: "",
        text: ""
      },
      "Optique": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Dentaire": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Hospitalisation": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Autre": {
        "_config": {
          icon: "",
          text: ""
        }
      },
    },
    "Envoi de devis pour un assuré santé": {
      "_config": {
        icon: "",
        text: ""
      },
      "Optique": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Dentaire": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Hospitalisation": {
        "_config": {
          icon: "",
          text: ""
        }
      },
      "Autre": {
        "_config": {
          icon: "",
          text: ""
        }
      },
    },
    "Demande de convention": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Virement non identifié": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Changement d'IBAN et/ou d'adresse": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
    "Sinistre en cours": {
      "_config": {
        icon: "",
        text: ""
      },
    },
    "Un autre sujet": {
      "_config": {
        icon: "",
        text: ""
      },
      "Oui": {},
      "Non": {},
    },
  },
  "Une candidature": {
    "_config": {
      icon: "candidat",
      text: ""
    }
  }
};

export const objetDuMessageData = {
  "Apporter une information": {},
  "Faire une demande": {},
  "Déclarer un sinistre": {},
  "Signaler un problème": {},
  "Autre": {}
};

export const objetDuMessageAutreData = {
  "Apporter une information": {},
  "Faire une demande": {},
  "Signaler un problème": {},
  "Autre": {}
};

export const objetDuMessageSanteData = {
  "Ma carte de tiers payant": {},
  "Un remboursement": {},
  "Mon adhésion": {},
  "Mes identifiants / ma connexion à Mon Espace Verspieren": {},
  "Mes bénéficiaires": {},
  "La portabilité": {},
  "La télétransmission": {},
  "Un autre sujet": {}
};
export const objetDuMessageSante2Data = {
  "Ma carte de tiers payant": {},
  "Un remboursement": {},
  "Mon adhésion": {},
  "Mes identifiants": {},
  "Mes bénéficiaires": {},
  "La portabilité": {},
  "La télétransmission": {},
  "Un autre sujet": {}
};

export const modeDeContactData = {
  "Téléphone": {},
  "E-mail": {}
};

export const momentDeContactData = {
  "Le matin": {},
  "L’après-midi": {}
};

export const typeDeSocieteData = {
  "Entreprise privée": {},
  "Organisme public": {},
  "Start-up": {},
  "Auto-entreprise / Micro-entreprise": {},
  "Régime travailleur indépendant / Travailleur non salarié": {},
  "Profession réglementée": {},
  "Profession libérale": {},
  "Fédération sportive": {},
  "Association / Fondation / ONG": {},
  "Autre": {}
};

export const secteurActiviteData = {
  "Automobile": {},
  "Assurance - Banque - Patrimoine": {},
  "Construction": {},
  "Expertise comptable - Audit": {},
  "Immobilier": {},
  "Sécurité": {},
  "VTC": {},
  "Autre": {}
};

export const chiffreAffaireData = {
  "Moins de 10 millions d'euros": {},
  "Plus de 10 millions d'euros": {}
};

export const effectifData = {
  "Moins de 50 collaborateurs": {},
  "De 50 à 100 collaborateurs": {},
  "Plus de 100 collaborateurs": {}
};

export const departementData = {
  "01 - Ain": {},
  "02 - Aisne": {},
  "03 - Allier": {},
  "04 - Alpes-de-Haute-Provence": {},
  "05 - Hautes-Alpes": {},
  "06 - Alpes-Maritimes": {},
  "07 - Ardèche": {},
  "08 - Ardennes": {},
  "09 - Ariège": {},
  "10 - Aube": {},
  "11 - Aude": {},
  "12 - Aveyron": {},
  "13 - Bouches-du-Rhône": {},
  "14 - Calvados": {},
  "15 - Cantal": {},
  "16 - Charente": {},
  "17 - Charente-Maritime": {},
  "18 - Cher": {},
  "19 - Corrèze": {},
  "2A - Corse-du-Sud": {},
  "2B - Haute-Corse": {},
  "21 - Côte-d'Or": {},
  "22 - Côtes-d'Armor": {},
  "23 - Creuse": {},
  "24 - Dordogne": {},
  "25 - Doubs": {},
  "26 - Drôme": {},
  "27 - Eure": {},
  "28 - Eure-et-Loir": {},
  "29 - Finistère": {},
  "30 - Gard": {},
  "31 - Haute-Garonne": {},
  "32 - Gers": {},
  "33 - Gironde": {},
  "34 - Hérault": {},
  "35 - Ille-et-Vilaine": {},
  "36 - Indre": {},
  "37 - Indre-et-Loire": {},
  "38 - Isère": {},
  "39 - Jura": {},
  "40 - Landes": {},
  "41 - Loir-et-Cher": {},
  "42 - Loire": {},
  "43 - Haute-Loire": {},
  "44 - Loire-Atlantique": {},
  "45 - Loiret": {},
  "46 - Lot": {},
  "47 - Lot-et-Garonne": {},
  "48 - Lozère": {},
  "49 - Maine-et-Loire": {},
  "50 - Manche": {},
  "51 - Marne": {},
  "52 - Haute-Marne": {},
  "53 - Mayenne": {},
  "54 - Meurthe-et-Moselle": {},
  "55 - Meuse": {},
  "56 - Morbihan": {},
  "57 - Moselle": {},
  "58 - Nièvre": {},
  "59 - Nord": {},
  "60 - Oise": {},
  "61 - Orne": {},
  "62 - Pas-de-Calais": {},
  "63 - Puy-de-Dôme": {},
  "64 - Pyrénées-Atlantiques": {},
  "65 - Hautes-Pyrénées": {},
  "66 - Pyrénées-Orientales": {},
  "67 - Bas-Rhin": {},
  "68 - Haut-Rhin": {},
  "69 - Rhône": {},
  "70 - Haute-Saône": {},
  "71 - Saône-et-Loire": {},
  "72 - Sarthe": {},
  "73 - Savoie": {},
  "74 - Haute-Savoie": {},
  "75 - Paris": {},
  "76 - Seine-Maritime": {},
  "77 - Seine-et-Marne": {},
  "78 - Yvelines": {},
  "79 - Deux-Sèvres": {},
  "80 - Somme": {},
  "81 - Tarn": {},
  "82 - Tarn-et-Garonne": {},
  "83 - Var": {},
  "84 - Vaucluse": {},
  "85 - Vendée": {},
  "86 - Vienne": {},
  "87 - Haute-Vienne": {},
  "88 - Vosges": {},
  "89 - Yonne": {},
  "90 - Territoire de Belfort": {},
  "91 - Essonne": {},
  "92 - Hauts-de-Seine": {},
  "93 - Seine-Saint-Denis": {},
  "94 - Val-de-Marne": {},
  "95 - Val-d'Oise": {},
  "971 - Guadeloupe": {},
  "972 - Martinique": {},
  "973 - Guyane": {},
  "974 - La Réunion": {},
  "976 - Mayotte": {},
};
